import { Control } from './control';
import { Brand } from './brand';
import { Adapter } from './adapter';
import { environment } from '../../../environments/environment';
import { VibrationPowerMode } from './vibration-power-mode';
import { MachineGroup } from './machine-group';
import { MachineGroupSection } from './machine-group-section';
import { ModelDiameterRange } from './model-diameter-range';
import { TheoreticalMachine } from './theoretical-machine';

export class Model {
  constructor(
    public hash?: string,
    public name?: string,
    public order?: number,
    public imagePath?: string,
    public active?: boolean,
    public defaultTaskDeviation?: number,
    public reference?: number,
    public ip?: string,
    public ftpUser?: string,
    public ftpPassword?: string,
    public serverPath?: string,
    public logPath?: string,
    public alarmPath?: string,
    public programPath?: string,
    public cycle?: number,
    public control?: Control,
    public brand?: Brand,
    public adapter?: Adapter,
    public correctionFactor?: number,
    public defaultToolTime?: number,
    public defaultPieceTime?: number,
    public timeCorrector?: number,
    public vibrationPowerMode?: VibrationPowerMode,
    public readMode?: string,
    public workingModelGroup?: MachineGroup,
    public numberOfPaths?: number,
    public partsCounterPath?: number,
    public programReadLimit?: number,
    public continuousProductionVariable?: string,
    public continuousProductionVariablePath?: number,
    public continuousProductionVariableReversed?: boolean,
    public pauseMinTime?: number,
    public subprogramCodeLimitToSend?: number,
    public allowsWriting?: boolean,
    // Planner-engine attributes (consumed by FeederTypeScorer / DiameterCoincidenceScorer / PartLengthScorer).
    public feederType?: string,
    public maxPartLengthMm?: number,
    public supportsRearEjection?: boolean,
    public diameterRanges: ModelDiameterRange[] = [],
    public section?: MachineGroupSection,
    public theoreticalMachines: TheoreticalMachine[] = [],
  ) { }

  clone() {
    return new Model(
      this.hash,
      this.name,
      this.order,
      this.imagePath,
      this.active,
      this.defaultTaskDeviation,
      this.reference,
      this.ip,
      this.ftpUser,
      this.ftpPassword,
      this.serverPath,
      this.logPath,
      this.alarmPath,
      this.programPath,
      this.cycle,
      this.control,
      this.brand,
      this.adapter,
      this.correctionFactor,
      this.defaultToolTime,
      this.defaultPieceTime,
      this.timeCorrector,
      this.vibrationPowerMode,
      this.readMode,
      this.workingModelGroup,
      this.numberOfPaths,
      this.partsCounterPath,
      this.programReadLimit,
      this.continuousProductionVariable,
      this.continuousProductionVariablePath,
      this.continuousProductionVariableReversed,
      this.pauseMinTime,
      this.subprogramCodeLimitToSend,
      this.allowsWriting,
      this.feederType,
      this.maxPartLengthMm,
      this.supportsRearEjection,
      this.diameterRanges ? this.diameterRanges.map(r => new ModelDiameterRange(r.hash, r.label, r.minDiameterMm, r.maxDiameterMm)) : [],
      this.section,
      this.theoreticalMachines
  );
  }

  get nameReference() {
    return (this.reference) ? `${ this.name } ${ this.reference }` : this.name;
  }

  get controlName() {
    return this.control ? this.control.name : '';
  }

  get imageUrl() {
    return `${ environment.imageUrl }${ this.imagePath }`;
  }

  get brandImageUrl() {
    return this.brand ? `${ environment.imageUrl }${ this.brand.imagePath }` : ``;
  }

  get adapterName() {
    return this.adapter ? this.adapter.name : ``;
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/model.ts